import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(root)/components/typewriter/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/[locale]/(root)/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.20_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.101.0/node_modules/next/dist/client/app-dir/link.js");
